/**
 * Slides up a target element by animating its height, padding, and margin properties.
 *
 * This function first sets the height of the target element to its current height, then animates it to 0.
 * After the animation, the element is hidden and the overflow and transition properties are reset.
 *
 * @param {HTMLElement} target - The target element to animate.
 * @param {number} [duration=500] - The duration of the animation in milliseconds. Defaults to 500ms.
 */
const slideUp = (target, duration = 500) => {
  // Set up transition properties for the animation
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';

  // Set the initial height to the current height
  target.style.height = `${target.offsetHeight}px`;

  // Trigger reflow to apply the current height
  target.offsetHeight; // Forces the browser to calculate styles

  // Prepare styles for the slide-up effect
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;

  // Cleanup after the animation duration
  window.setTimeout(() => {
    target.style.display = 'none'; // Hide the element after sliding up
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

export default slideUp;
